module.exports = __webpack_public_path__ + "static/media/01_Bexs_logo_tagline_preferencial_RGB.029184c6.png";